import { useState } from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ProtocolsTab } from '@/modules/promotion-v2';
import { ActionIntentsTable, ActionIntentDetailsSidebar } from '@/modules/promoted-blueprints';
import { useWorkflowBlueprints } from '@/hooks';

const TABLE_LABELS = {
	intentHeader: 'Intent',
	subIntentsHeader: 'Reply templates',
	subIntentsSuffix: 'templates',
	enabledHeader: 'Serving',
	emptyMessage: 'No promoted replies yet.'
};

const SIDEBAR_LABELS = {
	intentLabel: 'Intent',
	subIntentsTitle: 'Reply templates',
	noSubIntentsText: 'No reply templates under this intent.'
};

type View = 'protocols' | 'replies';

export default function PromotedProtocolsV2() {
	const [view, setView] = useState<View>('protocols');
	const [openBlueprintId, setOpenBlueprintId] = useState<string | null>(null);
	const { data: workflowBlueprints, isLoading } = useWorkflowBlueprints();

	return (
		<div className='flex h-full'>
			<div className='flex flex-1 flex-col gap-6 overflow-y-auto p-4'>
				<div className='space-y-1'>
					<h1 className='text-base font-semibold'>Promoted Protocols V2</h1>
					<p className='text-sm text-muted-foreground'>
						Turn the replies Kim already got right on a protocol into reply templates the agent can serve.
					</p>
				</div>

				<Tabs value={view} onValueChange={(value) => setView(value as View)}>
					<TabsList>
						<TabsTrigger value='protocols'>Protocols</TabsTrigger>
						<TabsTrigger value='replies'>Promoted Replies</TabsTrigger>
					</TabsList>
				</Tabs>

				{view === 'protocols' ? (
					<ProtocolsTab />
				) : (
					<div className='flex flex-col gap-5'>
						<p className='rounded-md border bg-muted/40 px-3 py-2 text-xs text-muted-foreground'>
							Each intent&apos;s promoted blueprint and its reply templates. Open one to switch a template on or off,
							or to choose whether it sends by itself or as a draft for review.
						</p>
						<ActionIntentsTable
							workflowBlueprints={workflowBlueprints ?? []}
							isLoading={isLoading}
							onRowClick={(blueprint) => setOpenBlueprintId(blueprint.id)}
							labels={TABLE_LABELS}
						/>
					</div>
				)}
			</div>

			{openBlueprintId && (
				<ActionIntentDetailsSidebar
					blueprintId={openBlueprintId}
					onClose={() => setOpenBlueprintId(null)}
					labels={SIDEBAR_LABELS}
				/>
			)}
		</div>
	);
}
